import React, { FC } from 'react';
import { ScrollView } from 'react-native';
import AlreadyAMemberLink from '../../components/styled/AlreadyAMemberLink';
import ErrorText from '../../components/styled/ErrorText';
import HeaderOne from '../../components/styled/HeaderOne';
import HeaderTwo from '../../components/styled/HeaderTwo';
import Modal from '../../components/styled/Modal';
import LinearGradientButton from '../../components/styled/LinearGradientButton';
import Logo from '../../components/styled/Logo';
import View from '../../components/styled/View';
import VerificationCodeInput from '../../components/styled/VerificationCodeInput';
import styles from './styles';
import {
  CHECK_YOUR_EMAIL,
  KEEP_WINDOW_OPEN,
  WELCOME_HEADER,
  WELCOME_SUB_HEADER,
} from './constants';
import GalanoGrotesqueText from '../../components/styled/GalanoGrotesqueText';
import Link from '../../components/styled/Link';
import UserError, { UserErrorCodes } from '../../components/styled/UserError';

type VerifyUserProps = {
  confirmEmailAddress: () => void;
  email: string;
  finishUserSetup: boolean;
  modalMessage: string;
  modalOverrideOnPress?: () => void;
  modalVisible: boolean;
  navigation: any;
  resendCode: () => void;
  setVerificationCode: (value: string) => void;
  setModalVisible: (value: boolean) => void;
  verifyError: string;
  verifyLoading: boolean;
  verificationCode: string;
};

const VerifyUser: FC<VerifyUserProps> = ({
  confirmEmailAddress,
  email,
  finishUserSetup,
  modalMessage,
  modalVisible,
  modalOverrideOnPress,
  navigation,
  resendCode,
  setVerificationCode,
  setModalVisible,
  verifyError,
  verifyLoading,
  verificationCode,
}) => {
  if (finishUserSetup) {
    return (
      <ScrollView contentContainerStyle={styles.contentContainer}>
        <Modal
          messageText={modalMessage}
          modalVisible={modalVisible}
          onPressOverride={modalOverrideOnPress}
          setModalVisible={setModalVisible}
        />
        <UserError
          errorType={UserErrorCodes.VERIFICATION_ERROR}
          handleUserErrorOverride={resendCode}
          navigation={navigation}
        />
      </ScrollView>
    );
  }
  return (
    <ScrollView contentContainerStyle={styles.contentContainer}>
      <Modal
        messageText={modalMessage}
        modalVisible={modalVisible}
        setModalVisible={setModalVisible}
      />
      <View style={styles.logo}>
        <Logo />
      </View>
      <HeaderOne title={WELCOME_HEADER} />
      <View style={styles.subHeader}>
        <HeaderTwo title={WELCOME_SUB_HEADER} />
      </View>
      <View style={styles.emailContainer}>
        <GalanoGrotesqueText style={styles.checkEmailText}>
          {CHECK_YOUR_EMAIL}
          <GalanoGrotesqueText style={styles.emailText}>
            {email}
          </GalanoGrotesqueText>
        </GalanoGrotesqueText>
      </View>
      <View style={styles.emailContainer}>
        <GalanoGrotesqueText style={styles.checkEmailText}>
          {KEEP_WINDOW_OPEN}
        </GalanoGrotesqueText>
      </View>
      <VerificationCodeInput
        onChangeText={(value) => setVerificationCode(value)}
        value={verificationCode}
      />
      <View style={styles.buttonContainer}>
        <LinearGradientButton
          disabled={verifyLoading}
          onPress={confirmEmailAddress}
          title="Verify"
        />
      </View>
      {!!verifyError && (
        <ErrorText textStyle={styles.verifyErrorText} text={verifyError} />
      )}
      <View style={styles.buttonContainer}>
        <Link
          onPress={resendCode}
          text="Resend Code"
          textStyle={styles.resendLink}
        />
      </View>
      <AlreadyAMemberLink navigation={navigation} />
    </ScrollView>
  );
};

export default VerifyUser;
